export const PROJECT_IMAGES_PATH = '/assets/images/';